import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RestService } from 'src/app/services/rest.service';
import { AuthService } from 'src/app/services/auth.service';
import { SMA } from 'src/app/models/sma';

interface DialogViewSmaData {
  licenceGuid: string;
  licenceName: string;
}

@Component({
  selector: 'app-dialog-view-sma',
  templateUrl: './dialog-view-sma.component.html',
  styleUrl: './dialog-view-sma.component.scss'
})
export class DialogViewSmaComponent implements OnInit {
  smas: SMA[] = [];
  loading = true;

  get isAdminOrOperator(): boolean {
    return this.authService.role === 'Admin' || this.authService.role === 'Operator';
  }

  constructor(
    public dialogRef: MatDialogRef<DialogViewSmaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogViewSmaData,
    private restService: RestService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.restService.get<any>(`/licences/period?licenceId=${this.data.licenceGuid}`).subscribe({
      next: (response) => {
        const rawData: any[] = Array.isArray(response) ? response : (response?.data ?? []);
        this.smas = rawData.map((item: any) => ({
          id: item.ID || item.id,
          guid: item.GUID || item.guid,
          licence_id: item.LicenceID || item.licence_id,
          document_number: item.DocumentNumber || item.document_number || '',
          product_id: item.ProductID || item.product_id || '',
          start_date: item.StartDate || item.start_date,
          end_date: item.EndDate || item.end_date,
          sma_booked: item.SMABooked || item.sma_booked || false,
          company_name: item.CompanyName || item.company_name || '',
          project_name: item.ProjectName || item.project_name || '',
          project_number: item.ProjectNumber || item.project_number || '',
          customer_order_number: item.CustomerOrderNumber || item.customer_order_number || ''
        }));
        this.loading = false;
      },
      error: () => {
        this.smas = [];
        this.loading = false;
      }
    });
  }

  unassignSma(sma: SMA): void {
    if (!sma.guid) return;
    this.restService.patch<any>(`/licences/sma/${sma.guid}/unassign`, {}).subscribe({
      next: () => {
        this.smas = this.smas.filter(s => s.guid !== sma.guid);
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
